<script setup>
import { computed } from "vue";
import { articles } from "../data/articles";
import { localeInfo, siteCopy } from "../data/content";
import IconArrow from "../components/IconArrow.vue";
import SiteFooter from "../components/SiteFooter.vue";
import SiteHeader from "../components/SiteHeader.vue";

const props = defineProps({
  locale: { type: String, required: true },
});

const site = computed(() => siteCopy[props.locale]);
const copy = computed(() => site.value.blog);

function formatDate(value) {
  return new Intl.DateTimeFormat(localeInfo[props.locale].htmlLang, { dateStyle: "medium" })
    .format(new Date(`${value}T12:00:00`));
}
</script>

<template>
  <div class="site-page inner-page" :lang="locale">
    <SiteHeader :locale="locale" :nav="site.nav" path="/blog" />
    <main id="main">
      <section class="page-hero page-hero--journal">
        <div class="shell">
          <p class="eyebrow">{{ copy.kicker }}</p>
          <h1>{{ copy.title }}</h1>
          <p>{{ copy.description }}</p>
        </div>
      </section>

      <section class="section blog-index">
        <div class="shell article-grid">
          <article
            v-for="(article, index) in articles"
            :key="article.slug"
            :class="['article-card', { 'article-card--featured': index === 0 }]"
            data-reveal
          >
            <RouterLink
              class="article-card__image"
              :to="`/${locale}/blog/${article.slug}`"
              :aria-label="article.content[locale].title"
            >
              <img
                :src="article.image"
                alt=""
                width="960"
                height="600"
                :loading="index === 0 ? 'eager' : 'lazy'"
              >
              <span>{{ String(index + 1).padStart(2, "0") }}</span>
            </RouterLink>
            <div class="article-card__body">
              <div class="article-card__meta">
                <time :datetime="article.updatedAt">{{ formatDate(article.updatedAt) }}</time>
                <span>{{ article.readingMinutes }} {{ copy.minutes }}</span>
              </div>
              <h2>
                <RouterLink :to="`/${locale}/blog/${article.slug}`">
                  {{ article.content[locale].title }}
                </RouterLink>
              </h2>
              <p>{{ article.content[locale].summary }}</p>
              <RouterLink class="inline-link" :to="`/${locale}/blog/${article.slug}`">
                {{ copy.read }}<IconArrow />
              </RouterLink>
            </div>
          </article>
        </div>
      </section>
    </main>
    <SiteFooter :locale="locale" :copy="site.footer" />
  </div>
</template>
